import React, { useState } from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import './TableViewPagination.css'
const TableViewPagination = props => {
    const [jumpToPage,setJumpToPage]=useState(undefined)
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        padding,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const handleJumpToPage = () => {
        const pageNumber = Number.parseInt(jumpToPage)
        if (pageNumber >= 1 && pageNumber <= lastPage) {
          onPageChange(pageNumber)
          setJumpToPage("")
        } else return ;
      }
    
      const handleKeyPress = (e) => {
        if (e.key === "Enter") {
          handleJumpToPage()
        }
      }
    

    const handleInputChange = (e) => {
        const value = e.target.value
        if (value === "" || /^\d+$/.test(value)) {
          setJumpToPage(value)
        }
      }

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        lastPage > 1 && <div style={{ padding: padding || "20px 0", display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
            {
                <div style={{display:"flex",gap:"1.5rem",alignItems:"center"}}>
                    <div style={{ color: "#727272", fontSize: "13px" }}>Page {currentPage} of {lastPage}</div>
                    <div className="jump-to-page">
                       <div className="jump-input-group">
                            <input style={{height:"22px",width:"66px"}}
                            type="text"
                            placeholder="Jump to"
                            value={jumpToPage}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyPress}
                            className="jump-input"
                            aria-label="Jump to"
                            />
                            <button style={{height:"22px",fontSize:"9px"}} className="go-button" onClick={handleJumpToPage} disabled={!jumpToPage}>
                            Go
                            </button>
                         </div>
                 </div>
                </div>
            }
           
            {
                <div>
                    <ul
                        className={classnames('pagination-container', "pagination-bar")}
                    >
                        {/* Left navigation arrow */}
                        <li
                            className={classnames('pagination-item', {
                                disabled: currentPage === 1
                            })}
                            onClick={onPrevious}
                        >
                            <div className="arrow left" />
                        </li>
                        {paginationRange.map(pageNumber => {

                            // If the pageItem is a DOT, render the DOTS unicode character
                            if (pageNumber === DOTS) {
                                return <li className="pagination-item dots">&#8230;</li>;
                            }

                            // Render our Page Pills
                            return (
                                <li
                                    className={classnames('pagination-item', {
                                        selected: pageNumber === currentPage
                                    })}
                                    onClick={() => {
                                        if (currentPage !== pageNumber) onPageChange(pageNumber)
                                    }}
                                >
                                    {pageNumber}
                                </li>
                            );
                        })}
                        {/*  Right Navigation arrow */}
                        <li
                            className={classnames('pagination-item', {
                                disabled: currentPage === lastPage
                            })}
                            onClick={onNext}
                        >
                            <div className="arrow right" />
                        </li>
                    </ul>
                </div>}
        </div>
    );
};

export default TableViewPagination;
